module.exports = __webpack_public_path__ + "static/media/s2.ef499e12.ogg";